export default "__VITE_ASSET__DAjn2eFr__"